export type BeatName = 'raw' | 'detect' | 'lift' | 'land'

/** Global progress windows. Contiguous, covering 0..1. */
export const BEATS: Record<BeatName, [number, number]> = {
  raw: [0, 0.18],
  detect: [0.18, 0.45],
  lift: [0.45, 0.72],
  land: [0.72, 1],
}

const ORDER: BeatName[] = ['raw', 'detect', 'lift', 'land']

/** Fraction of a beat by which each successive card is delayed. */
export const CARD_STAGGER = 0.05

/** Minimum window width for a card animation. */
export const MIN_CARD_WINDOW = 0.04

const clamp = (n: number, min = 0, max = 1) => Math.min(max, Math.max(min, n))

export function beatAt(progress: number): BeatName {
  const p = clamp(progress)
  for (const name of ORDER) {
    const [, end] = BEATS[name]
    if (p < end) return name
  }
  return 'land'
}

export function beatProgress(progress: number, beat: BeatName): number {
  const [start, end] = BEATS[beat]
  return clamp((clamp(progress) - start) / (end - start))
}

/**
 * Returns the global progress window for one card of `count` cards in a beat.
 * All windows in a beat are equal width, and the last card's window ends on the beat's end.
 */
export function cardRange(
  beat: BeatName,
  index: number,
  count: number
): [number, number] {
  const [start, end] = BEATS[beat]
  const span = end - start
  const totalStagger = CARD_STAGGER * Math.max(0, count - 1)
  const usable = Math.max(MIN_CARD_WINDOW, span - totalStagger)
  const cardStart = clamp(start + index * CARD_STAGGER, 0, 1 - MIN_CARD_WINDOW)
  const cardEnd = clamp(cardStart + usable, cardStart + MIN_CARD_WINDOW, 1)
  return [cardStart, cardEnd]
}
